import { render, staticRenderFns } from "./verify-site-change.vue?vue&type=template&id=a90911f4&scoped=true&"
import script from "./verify-site-change.vue?vue&type=script&lang=js&"
export * from "./verify-site-change.vue?vue&type=script&lang=js&"
import style0 from "./verify-site-change.vue?vue&type=style&index=0&id=a90911f4&prod&lange=scsss&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a90911f4",
  null
  
)

export default component.exports